'use client';
import { useMediaQuery } from 'react-responsive';
import type { LinkProps, LinkObj } from '@repo/ui/src/types/link';
import type { HeaderVariationProps } from '@repo/ui/src/types/headerVariation';
import type { HeaderVariation } from '@repo/ui/src/types/headerVariation';
import HeaderVariety from '@primitives/HeaderVariety';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';

interface TwoThirdsDescriptionProps {
  firstParagraph?: string;
  secondParagraph?: string;
  linkObj: LinkObj | null;
}

const TwoThirdsDescription = ({ firstParagraph, secondParagraph, linkObj }: TwoThirdsDescriptionProps) => {
  return (
    <div className="col-12 col-md-8">
      <div className="row">
        <div className="col-12 col-lg-6">
          <p>{firstParagraph}</p>
        </div>
        <div className="col-12 col-lg-6">
          <p>{secondParagraph}</p>
          {linkObj && (
            <a rel={getRel(linkObj)} href={linkObj.href}>
              <div className="underline font-bold">{linkObj.text}</div>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

interface TwoThirdsTitleProps {
  title?: string;
  headerVariation?: HeaderVariation | '';
}

const TwoThirdsTitle = ({ title, headerVariation }: TwoThirdsTitleProps) => {
  return (
    <div className="col-12 col-md-4 px-lg-4">
      <HeaderVariety defaultVariation="h2" headerVariation={headerVariation} classNames="mb-6">
        {' '}
        {title}{' '}
      </HeaderVariety>
    </div>
  );
};

interface TwoThirdsTextProps {
  title?: string;
  firstParagraph?: string;
  secondParagraph?: string;
  splitPosition?: string;
  link?: Array<LinkProps>;
  headerVariation?: HeaderVariationProps;
}

const TwoThirdsText = (props: TwoThirdsTextProps) => {
  const { title, firstParagraph, secondParagraph, splitPosition, link, headerVariation } = props;
  const linkObj: LinkObj | null =
    link && Array.isArray(link) && link[0] ? buildLinkObj(link[0]) : null;
  const isMediumOrSmaller = useMediaQuery({ query: '(max-width: 767px' });
  return (
    <div className="jumbotron rotating-background d-flex justify-content-center mb-0">
      <div className="container">
        {isMediumOrSmaller || splitPosition === 'Title-left_Description-right' ? (
          <div className="row">
            <TwoThirdsTitle title={title} headerVariation={headerVariation?.headerVariation} />
            <TwoThirdsDescription
              firstParagraph={firstParagraph}
              secondParagraph={secondParagraph}
              linkObj={linkObj}
            />
          </div>
        ) : (
          <div className="row">
            <TwoThirdsDescription
              firstParagraph={firstParagraph}
              secondParagraph={secondParagraph}
              linkObj={linkObj}
            />
            <TwoThirdsTitle title={title} headerVariation={headerVariation?.headerVariation} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TwoThirdsText;
